import React from 'react';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import ImageComponent from 'atoms/Image';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { AnchorWithLink } from 'atoms/Anchor';
import { useHistory } from 'react-router-dom';
import { redirectToNutritionAllergenLandingPage } from 'common/utilities/utils';
import { NUTRITION_ALLERGEN_CONSTANTS } from 'organisms/NutritionAllergen/Constants/NutritionAllergenConstant';
const AllergenContainer = props => {
  const { allergenDetails, customizable, handleCloseModal, source } = props;
  let history = useHistory();
  const navigateToNutritionLandingPage = () => {
    if (source === NUTRITION_ALLERGEN_CONSTANTS.SOURCE) {
      handleCloseModal();
    }
    redirectToNutritionAllergenLandingPage(history);
  };

  const nonAlaCarteAllergen = (
    <div className='non-ala-carte-notification'>
      <div className='notification-alert'>
        <ImageComponent srcFile={IMAGE_PATH.Error_Yellow} className='non-ala-carte-alert-icon' />
        <div
          className='non-ala-carte-alert-text'
          data-testid='navigation-click-testId'
          onClick={() => navigateToNutritionLandingPage()}
        >
          <span>{translateWithI18Next(TRANSLATE_MAPPING_KEY.NON_ALA_CARTE_ALERT_TEXT)}</span>
          <span className='non-ala-carte-alert-link-text'>
            <AnchorWithLink className='non-ala-carte-alert-link' data-testid='non-ala-carte-alert-link-info'>
              {translateWithI18Next(TRANSLATE_MAPPING_KEY.NON_ALA_CARTE_ALERT_LINK)}
            </AnchorWithLink>
          </span>
        </div>
      </div>
    </div>
  );
  const alaCarteAllergen = (
    <>
      <div className='allergen-information'>
        <div className='allergen-notify-present'>
          <ImageComponent srcFile={IMAGE_PATH.Error_Red} className='alert-icon' />
          <div>
            <span className='allergen-text'>{translateWithI18Next(TRANSLATE_MAPPING_KEY.ALLERGEN_PRESENT_TEXT)}</span>
            &nbsp;
            <span>{translateWithI18Next(TRANSLATE_MAPPING_KEY.ALLERGEN_PRESENT_DETAILS)}</span>
          </div>
        </div>
        <div className='allergen-notify-trace'>
          <ImageComponent srcFile={IMAGE_PATH.Error_Black} className='alert-icon-trace' />
          <div>
            <span className='allergen-text'>{translateWithI18Next(TRANSLATE_MAPPING_KEY.ALLERGEN_TRACE_TEXT)}</span>
            &nbsp;
            <span>{translateWithI18Next(TRANSLATE_MAPPING_KEY.ALLERGEN_TRACE_DETAILS)}</span>
          </div>
        </div>
      </div>
      <div className='allergen-details-global'>
        <table>
          {allergenDetails?.map(item => {
            return (
              <>
                <tr>
                  <td className='allergen-component'>{item?.allergenComponent}</td>
                  {item?.isPresent && (
                    <td className='allergen-icon'>
                      <ImageComponent srcFile={IMAGE_PATH.Error_Red} />
                    </td>
                  )}
                  {item?.isTrace && (
                    <td className='allergen-icon-trace'>
                      <ImageComponent srcFile={IMAGE_PATH.Error_Black} />
                    </td>
                  )}
                  {!item?.isTrace && !item?.isPresent && (
                    <td className='allergen-icon-text'>{translateWithI18Next(TRANSLATE_MAPPING_KEY.NOT_APPLICABLE)}</td>
                  )}
                </tr>
              </>
            );
          })}
        </table>
      </div>
    </>
  );
  return (
    <React.Fragment>
      <div className='allergen-header-global'>
        <div className='allergen-name-global'>{translateWithI18Next(TRANSLATE_MAPPING_KEY.ALLERGEN)}</div>
      </div>
      {customizable ? nonAlaCarteAllergen : alaCarteAllergen}
    </React.Fragment>
  );
};
export default AllergenContainer;
